export const SMALL_PREVIEW_SIZE = 100
export const PREVIEW_CONTROL = 'preview_control'
